module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": "",
      "touchless": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": 0
    }
  }, [_c('create-statement-form', {
    attrs: {
      "relationship-id": _vm.relationshipId,
      "invoices": _vm.invoices
    },
    on: {
      "success": _vm.statementCreated
    }
  })], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 1
    }
  }, [(_vm.newstatement) ? _c('statement-success', {
    attrs: {
      "statement": _vm.newstatement
    },
    on: {
      "send": function($event) {
        _vm.step = 2
      },
      "close": function($event) {
        return _vm.$emit("close")
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-window-item', {
    attrs: {
      "value": 2
    }
  }, [(_vm.newstatement) ? _c('send-statement', {
    attrs: {
      "touch": _vm.touchSender
    },
    on: {
      "close": function($event) {
        return _vm.$emit("close")
      }
    },
    model: {
      value: (_vm.newstatement),
      callback: function($$v) {
        _vm.newstatement = $$v
      },
      expression: "newstatement"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-192d3d23","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/Statement/index.vue
// module id = 1344
// module chunks = 9